package team.platforma.materialextension.moc_data

import team.platforma.multiplatform_material_extension.ui.drop_down.model.ListItem

class MocCity {
    private val mapRegionCity =
        mutableMapOf<ListItem, List<ListItem>>() // parent && children

    init {
        val mskRegion = ListItem(1, "Москва")
        val spbRegion = ListItem(2, "Санкт-Петербург")
        val nnRegion = ListItem(3, "Нижегородская область")

        val citiesMsk = listOf(
            ListItem(101, "Москва"),
            ListItem(102, "Зеленоград"),
            ListItem(103, "Московский"),
            ListItem(104, "Троицк"),
            ListItem(104, "Щербинка")
        )

        val citiesSpb = listOf(
            ListItem(201, "Санкт-Петербург"),
            ListItem(202, "Левашово"),
            ListItem(203, "Парголово"),
            ListItem(204, "Колпино"),
            ListItem(205, "Металлострой"),
            ListItem(206, "Понтонный"),
            ListItem(207, "Сапёрный"),
            ListItem(208, "Усть-Ижора"),
        )

        val citiesNn = listOf(
            ListItem(301, "Нижний Новгород"),
            ListItem(302, "Арзамас"),
            ListItem(303, "Балахна"),
            ListItem(304, "Богородск"),
            ListItem(305, "Бор"),
            ListItem(306, "Ветлуга"),
            ListItem(307, "Володарск"),
            ListItem(308, "Ворсма"),
            ListItem(309, "Выкса"),
            ListItem(310, "Горбатов"),
            ListItem(311, "Городец"),
            ListItem(312, "Дзержинск"),
        )
        mapRegionCity[mskRegion] = citiesMsk
        mapRegionCity[spbRegion] = citiesSpb
        mapRegionCity[nnRegion] = citiesNn
    }

    fun searchRegion(query: String): List<ListItem> {
        return mapRegionCity.keys.filter { it.title.contains(query, ignoreCase = true) }
    }

    fun searchCity(regionId: Long?, query: String): List<ListItem> {

        val cityList = mutableListOf<ListItem>()

        var resultList = mutableListOf<ListItem>()

        mapRegionCity.forEach { (key, value) ->
            value.forEach {
                if (it.title.contains(query, ignoreCase = true)) {
                    cityList.add(ListItem(id = it.id, title = it.title, parent = key))
                }
            }
        }

        if (regionId != null) {
            resultList = cityList.filter { it.parent?.id == regionId }.toMutableList()
        } else {
            resultList = cityList
        }


        return resultList
    }

}